module.exports = __webpack_public_path__ + "img/ESTADAO.c9eae6ff.png";